var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"training"},[_c('header',[_c('h1',[_vm._v(" "+_vm._s(_vm.$t("training.home.cards.Advisor.title"))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t("training.Advisor.subtitle"))+" ")])]),_c('section',[_c('p',[_vm._v(" "+_vm._s(_vm.$t("training.home.cards.Advisor.subtitle"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }